@if (this.showTable) {
  <snelstart-ui-table [config]="tableConfig" loadType="Pagination" style="min-height: 210px;">
    <snelstart-ui-table-col name="open" displayName="Datum" width="120px">
      <snelstart-ui-table-col-data>
        <ng-template let-dateCreation>
          @if(dateCreation === undefined) {
            <ng-container>
              <a>niet bekend</a>
            </ng-container>
          } @else {
            {{dateCreation | date: 'dd-MM-yyyy'}}
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col name="actie" displayName="Omschrijving" [showFilter]="false" [showSort]="false" width="500px">
    </snelstart-ui-table-col>
    <snelstart-ui-table-col name="soort" displayName="Aangemaakt door" columnType="string" width="200px">
      <snelstart-ui-table-col-data>
        <ng-template let-creator>
          {{creator || 'SnelStart'}}
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
<!--    <snelstart-ui-table-col name="deadline" displayName="Deadline" columnType="date">-->
<!--      <snelstart-ui-table-col-data>-->
<!--        <ng-template let-dateDeadline>-->
<!--          {{dateDeadline | date: 'dd-MM-yyyy'}}-->
<!--        </ng-template>-->
<!--      </snelstart-ui-table-col-data>-->
<!--    </snelstart-ui-table-col>-->
    <snelstart-ui-table-col name="attachment" displayName="Bijlage" columnType="string" width="100px">
      <snelstart-ui-table-col-data>
        <ng-template let-attachment>
          @if(attachment !== undefined && attachment) {
            <ng-container>
                <span snelstartUiTooltip="Klik om te openen">
                <snelstart-ui-icon name="paperclip"></snelstart-ui-icon>
                </span>
            </ng-container>
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
  </snelstart-ui-table>
}

<snelstart-venture-fiscaal-domain-logic-workflow [(dialogVisible)]="this.dialogVisible"
                                                 [id]="this.client.sstRelationId"
                                                 [type]=this.type>
</snelstart-venture-fiscaal-domain-logic-workflow>
